import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import CardMenu from "./CardMenu";
import { toast } from "react-toastify";
import { checkErrorMessage, checkResponseData } from "../../utils/utils";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import { Typography, IconButton, Divider, Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArchiveIcon from "@mui/icons-material/Archive";
import AlertCards from "./AlertCards";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { answerCardApi, deleteCardApi } from "../../../services/leitnerApi";
import {
  separationCards,
  answerCard,
  pickNewCard,
  returnAnswerLevel,
  handleDeleteCard,
} from "./studyCardUtils";
import TopOfCards from "./TopOfCards";
import FrontCard from "./FrontCard";
import BackCard from "./BackCard";
import EditCards from "./EditCards/EditCards";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function StudyCards(props) {
  const {
    controlThemeMode,
    handleStartStudy,
    // handleStudyCards,
    studyCards,
    setBoxDetails,
  } = props;
  const [Info, setInfo] = useState({});
  const [cards, setCards] = useState(false);
  const [pickCard, setPickCard] = useState(false);
  const [answerLevel, setAnswerLevel] = useState({
    veryHard: 0,
    hard: 10,
    medium: 1,
    easy: 2,
  });
  const [showAnswer, setShowAnswer] = useState(false);
  const [alertDetails, setAlertDetails] = useState({
    openAlert: false,
    textAlert: "",
    typeAlert: "",
  });
  const [editCard, setEditCard] = useState({ editMode: false, card: null });

  const alertButton = (type) => {
    if (type == "home") {
      setAlertDetails({
        openAlert: true,
        textAlert: "می خواید به صفحه لیست لایتنر ها برگردید؟",
        typeAlert: "home",
      });
    } else if (type == "back") {
      setAlertDetails({
        openAlert: true,
        textAlert: "می خواید به صفحه جزییات لایتنر برگردید؟",
        typeAlert: "back",
      });
    }
  };

  const deleteButtonAlert = () => {
    setAlertDetails({
      openAlert: true,
      textAlert: "آیا میخواید کارت را حذف کنید؟",
      typeAlert: "delete",
    });
  };

  const confirmAlert = async (type) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    if (type == "cancel") {
      setAlertDetails({ openAlert: false, textAlert: "", typeAlert: "" });
      toast.update(toastMsg, { render: "درخواست انجام شد", type: "info", isLoading: false, autoClose: 3000 });
    } else if (type == "home") {
      setAlertDetails({ openAlert: false, textAlert: "", typeAlert: "" });
      handleStartStudy(false);
      setBoxDetails(false, null);
      toast.update(toastMsg, { render: "درخواست انجام شد", type: "info", isLoading: false, autoClose: 3000 });
    } else if (type == "back") {
      setAlertDetails({ openAlert: false, textAlert: "", typeAlert: "" });
      handleStartStudy(false);
      setBoxDetails(true, Info["_id"]);
      toast.update(toastMsg, { render: "درخواست انجام شد", type: "info", isLoading: false, autoClose: 3000 });
    } else if (type == "delete") {
      if (pickCard) {
        try {
          const res = await deleteCardApi({ cardId: pickCard["_id"] })
          const resData = checkResponseData(res);
          if (res["data"]["success"]) {
            let newAllcards = handleDeleteCard(pickCard, cards);
            setCards(newAllcards);
            setAlertDetails({ openAlert: false, textAlert: "", typeAlert: "" });
            toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
          } else {
            toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
          }
        } catch (error) {
          const errData = checkErrorMessage(error);
          let errMsg = errData["titles"] || errData["message"]
          toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
        }
      } else {
        // setAlertDetails({ openAlert: false, textAlert: "", typeAlert: "" });
        toast.update(toastMsg, { render: "انجام شد", type: "info", isLoading: false, autoClose: 3000 });
      }
    } else {
      toast.update(toastMsg, { render: "مشکلی وجود دراد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const handleShowAnswer = (state) => {
    setShowAnswer(state);
  };

  const handleEditCard = async (condition, newAllcards) => {
    if (condition == "doneEdit") {
      setCards(newAllcards);
      setEditCard({ editMode: false, card: null });
    } else if (condition == "cancelEdit") {
      setEditCard({ editMode: false, card: null });
    } else if (condition == "startEdit") {
      setEditCard({ editMode: true, card: pickCard });
    }
  };

  const handleaAnswerCard = async (level) => {
    const { card, newAllcards } = answerCard(
      pickCard,
      pickCard["learningLevel"],
      level,
      cards
    );
    // update data in back with card console.log(card)
    setCards(newAllcards);
    await answerCardApi({
      cardId: card["_id"],
      newLevel: card["learningLevel"],
    });
  };

  const setInfoAndCards = () => {
    const { boxInfo, boxCards } = studyCards;
    setCards(separationCards(boxCards));
    setInfo(boxInfo);
  };

  const pickNewCardFromCards = () => {
    // console.log("0000000000000000", cards);
    let card = pickNewCard(cards);
    setAnswerLevel(returnAnswerLevel(card));
    setPickCard(card);
    // console.log("4123456-pickcard", card);
  };

  useEffect(() => {
    // console.log("useEffect-setInfoAndCards");
    setInfoAndCards();
  }, [studyCards]);
  useEffect(() => {
    // console.log("useEffect-pickNewCardFromCards");
    if (cards) pickNewCardFromCards();
  }, [cards]);

  return (
    <>
      {editCard["editMode"] ? (
        <EditCards
          controlThemeMode={controlThemeMode}
          handleEditCard={handleEditCard}
          cards={cards}
          editCard={editCard}
        />
      ) : (
        <>
          <CardMenu
            controlThemeMode={controlThemeMode}
            handleEditCard={handleEditCard}
            pickCard={pickCard}
            deleteButtonAlert={deleteButtonAlert}
          />
          <CssBaseline />
          <TopOfCards alertButton={alertButton} Info={Info} cards={cards} />
          {/* </Box> */}
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={0.5}
            sx={{ p: 1 }}
          >
            {pickCard ? (
              <>
                <FrontCard pickCard={pickCard} />
                {showAnswer ? <BackCard pickCard={pickCard} /> : ""}
              </>
            ) : (
              <Item sx={{ color: "red" }}>
                <Typography>کارتی برای مرور وجود ندارد</Typography>
              </Item>
            )}

            {/* <Item sx={{ mt: 1, mx: 1 }}>Item 3</Item> */}
          </Stack>
          {pickCard ? (
            <Paper
              sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
              elevation={3}
            >
              {showAnswer ? (
                <BottomNavigation
                  showLabels
                  // value={value}
                  onChange={(event, newValue) => {
                    handleShowAnswer(false);
                  }}
                >
                  <BottomNavigationAction
                    label={
                      answerLevel["easy"] == "done"
                        ? "یاد گرفتم"
                        : `${answerLevel["easy"]} روز`
                    }
                    icon={<SentimentVerySatisfiedIcon />}
                    sx={{ bgcolor: "#BECA5C", color: "blue" }}
                    onClick={() => {
                      handleaAnswerCard(answerLevel["easy"]);
                    }}
                  />
                  <BottomNavigationAction
                    label={`${answerLevel["medium"]} روز`}
                    sx={{ bgcolor: "#EF8D32", color: "blue" }}
                    icon={<SentimentSatisfiedAltIcon />}
                    onClick={() => {
                      handleaAnswerCard(answerLevel["medium"]);
                    }}
                  />
                  <BottomNavigationAction
                    label={
                      answerLevel["hard"] == 10
                        ? `${answerLevel["hard"]} دقیقه`
                        : `${answerLevel["hard"]} روز`
                    }
                    sx={{ bgcolor: "#CC561E", color: "blue" }}
                    icon={<SentimentDissatisfiedIcon />}
                    onClick={() => {
                      handleaAnswerCard(answerLevel["hard"]);
                    }}
                  />
                  <BottomNavigationAction
                    label="1 دقیقه"
                    sx={{ bgcolor: "#AA2B1D", color: "blue" }}
                    icon={<SentimentVeryDissatisfiedIcon />}
                    onClick={() => {
                      handleaAnswerCard(answerLevel["veryHard"]);
                    }}
                  />
                </BottomNavigation>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    handleShowAnswer(true);
                  }}
                  color={"warning"}
                  sx={{ width: "100%", py: 2 }}
                  endIcon={<CheckCircleIcon />}
                >
                  مشاهده پاسخ
                </Button>
              )}
            </Paper>
          ) : (
            <Paper
              sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
              elevation={3}
            >
              <Button
                variant="contained"
                onClick={() => {
                  confirmAlert("home");
                }}
                color={"warning"}
                sx={{ width: "100%", py: 2 }}
                endIcon={<ExitToAppIcon />}
              >
                خروج
              </Button>
            </Paper>
          )}
          <AlertCards alertDetails={alertDetails} confirmAlert={confirmAlert} />
        </>
      )}
    </>
  );
}
